// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store/index.js";
import axios from "axios";
import Vant from 'vant';
import 'vant/lib/index.css';
import '@/assets/css/resetui.css'
import Qs from "qs";
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import 'babel-polyfill'
import PinchZoom from 'vue-pinch-zoom';
import JSONbig from "json-bigint"
import { init } from 'echarts';
import {description} from '../package.json'
Vue.component('pinch-zoom', PinchZoom);

Vue.use(Vant);
Vue.use(VueMoment, {
  moment,
});

Vue.config.productionTip = false;
axios.defaults.transformRequest = [function (data) {
  if (data.toString() == "[object FormData]") {
    return data;
  } else {
    return Qs.stringify(data)
  }
}];
axios.defaults.transformResponse=[(data) => {
  if (typeof data === 'string') {
    try {
      data = JSONbig.parse(data);
    } catch (e) { /* Ignore */ } // Added this Ignore as it's the same in the Axios
  }
  return data;
}];
// const host = process.env.NODE_ENV === "development" ? "http://api.stock.com/" : "https://pc_apiserver5618.hk9999.com/"; // 根据 process.env.NODE_ENV 的值判断当前是什么环境

// Dedicated axios instance for line reachability checks
const lineCheckHttp = axios.create({
  timeout: 1500,
  withCredentials: false,
  validateStatus: () => true,
  // Bypass global transforms for lightweight ping
  transformRequest: [data => data],
  transformResponse: [data => data]
});
console.log(description);
let isAppInit = false;

let initApp = function () {

  if (isAppInit) {
    console.log('vue already loaded.');
    return;
  } else {
    console.log('Vue  is not loaded.');
  }

  const instance = axios.create({
    baseURL: localStorage.lineUrl,
    timeout: 10000,
    withCredentials: true
  });

  instance.interceptors.response.use(
    function (response) {
      // Any status code within the range of 2xx will cause this function to trigger
      // You can check for custom success codes if necessary, but Axios treats any 2xx response as success
      return response; // Proceed with the response if successful
    },
    function (error) {
      // Any status codes outside the range of 2xx will cause this function to trigger
      if (error.message.includes('timeout')) {
        Vue.prototype.$toast.fail('线路访问失败，请切换线路。');
      }
      return Promise.reject(error);
    }
  );

  Vue.prototype.$http = instance;

  sessionStorage.removeItem('lineUrl')
  /**
     * wonder chat system start
     */
  const wonderChatInstace = axios.create({
    baseURL: process.env.WONDER_CHAT_ROOT,
    timeout: 10000,
    withCredentials: true
  });
  Vue.prototype.$wonderChat = wonderChatInstace;

  //end wonder chat system
  //Vue.prototype.$http = instance;

  //force logout and goto login
  Vue.prototype.$logout = function (msg) {
    this.$toast.fail(msg);
    setTimeout(() => {
      this.$store.commit("changeLoginType", false);
      sessionStorage.setItem("token", "");
      localStorage.clear();
      this.$router.push("/login");
      window.location.reload();
    }, 2000);
  };

  // Common loader
  Vue.prototype.$NoNetworkErrorMsg = "网络连接失败,稍后再试";

  Vue.prototype.$LoadFromDomain = process.env.LOAD_FROM_DOMAIN;
  Vue.prototype.$AutoLogin = process.env.AUTO_LOGIN;
  Vue.prototype.$DownloadPopup = process.env.DOWNLOAD_POPUP;

  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
  });

  router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
  });

  isAppInit = true;

}


Vue.prototype.$chatApiURL = process.env.WONDER_CHAT_ROOT;//"https://chat.hk99555.com/";

let Line_1 = window.__env.Line_1;//"https://server3299.hk99666.com/";
let Line_2 = window.__env.Line_2;//"https://server3299.hk99111.com/";



Vue.prototype.$URLs = [{ "id": 1, "name": "线路 1", "url": window.__env.API_ROOT }, { "id": 2, "name": "线路 2", "url": Line_1 }, { "id": 3, "name": "线路 3", "url": Line_2 }];

let lines = Vue.prototype.$URLs;

let workingLines = [];

let checkLine = function (url) {
  return new Promise((resolve, reject) => {
    if(url === null || url === undefined){reject();return;};
    lineCheckHttp.get(url).then(() => {
      console.log('line working inside checkLine',url);
      resolve();
    }).catch((e) => {
      console.log('line not working inside checkLine',url,e);
      reject();
    });
  });
}

async function startAppWithFirstWorkingLine(urls) {
  const [line1, ...fallbackLines] = urls;

  // Step 1: try Line 1 first (sequential await)
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);
    const res = await fetch(line1.url, { signal: controller.signal });
    clearTimeout(timeoutId);

    if (res.ok) {
      if (!isAppInit) {
        localStorage.setItem('lineUrl', line1.url);
        sessionStorage.setItem('lineUrl', line1.url);
        localStorage.setItem('lineUrlText', line1.name);
        sessionStorage.setItem('lineUrlText', line1.name);
        localStorage.setItem('lineUrlId', line1.id);
        sessionStorage.setItem('lineUrlId', line1.id);
      }
      initApp();
      return; // done — Line 1 worked
    }
  } catch (e) {
    console.warn('Line 1 failed, racing fallback lines...', e);
  }

  // Step 2: Line 1 failed — race remaining lines, fastest wins
  for (const item of fallbackLines) {
    try {
      const controller = new AbortController();
      const signal = controller.signal;
      const fetchPromise = fetch(item.url, { signal });

      // Set a timeout to abort the request after a certain time
      const timeoutId = setTimeout(() => {
        controller.abort();
        // Vue.prototype.$toast.fail('线路访问失败，请切换线路');
      }, 10000); // Abort after 5 seconds (adjust as needed)


      let startTime = new Date().getTime();
      fetchPromise.then((res) => {
        if (res.ok) {
          let ci = urls.find((o) => o.url === res.url);
          if (isAppInit) {}
          else{
            localStorage.setItem('lineUrl', ci.url);
            sessionStorage.setItem('lineUrl', ci.url);
            localStorage.setItem('lineUrlText', ci.name);
            sessionStorage.setItem('lineUrlText', ci.name);
            localStorage.setItem('lineUrlId', ci.id);
            sessionStorage.setItem('lineUrlId', ci.id);
          }
          clearInterval(timeoutId);

          let endTime = new Date().getTime();
          let elapsedTime = endTime - startTime;
          let i = {};
          i.time = elapsedTime;
          i.url = ci.url;
          i.name = ci.name;
          i.id = ci.id;

          workingLines.push(item);
        }

        initApp();
        return;
      });

      fetchPromise.catch((error) => {
        clearInterval(timeoutId);
        console.error(`Error fetching URL ${item.url}:`, error);
      })
    } catch (error) {
      clearInterval(timeoutId);
      console.error(`Error fetching URL ${item.url}:`, error);
    }

  }
  // If we reach here, no working URL was found
  console.log('No working URL found.');
}
//check url param fixed api line
const urlParams = new URLSearchParams(window.location.hash.split('?')[1])
const paramValue = urlParams.get('line');
if (paramValue) {
  let lineNum = paramValue.split('api')[1];
  let paramLine = lines[parseInt(lineNum) - 1];

  localStorage.setItem('lineUrl', paramLine.url);
  sessionStorage.setItem('lineUrl', paramLine.url);
  localStorage.setItem('lineUrlText', paramLine.name);
  sessionStorage.setItem('lineUrlText', paramLine.name);
  localStorage.setItem('lineUrlId', paramLine.id);
  sessionStorage.setItem('lineUrlId', paramLine.id);

}

let storedLine = localStorage.lineUrl;
let checkLineCall = localStorage.getItem("checkLineCall") || 0;
if(checkLineCall == 1){
  localStorage.setItem("checkLineCall", 0);
  checkLine(storedLine).then(() => {
    workingLines = lines;
    initApp();
  }).catch(() => {
    startAppWithFirstWorkingLine(lines);
  })
}else{
  startAppWithFirstWorkingLine(lines);
}



// WEBPACK FOOTER //
// ./src/main.js